export default __webpack_public_path__ + "static/media/pheasant@3x.805584ef.jpg";